import { createSelector } from 'reselect';

export const activitySelector = (state) => state.activity;

export const activityListSelector = createSelector(
    activitySelector,
    (access) => access.activityList,
);
